import React from "react";
// Framed section card (DESIGN.md §3) — never nest one inside another.
export function SectionCard({ icon, title, action, children, className, bodyClassName }) {
    const hasHeader = !!title || !!action;
    return (<section className={`rounded-xl border border-line bg-white p-4 ${className ?? ""}`}>
            {hasHeader && (<div className={"mb-3 flex items-center justify-between gap-2 border-b border-line pb-2.5"}>
                    <div className={"flex items-center gap-2 text-sm font-semibold tracking-title text-gray-700 [&>svg]:text-brand-600"}>
                        {icon}
                        {title}
                    </div>
                    {action}
                </div>)}
            <div className={bodyClassName}>{children}</div>
        </section>);
}
export default SectionCard;
//# sourceMappingURL=sectionCard.jsx.map